import BaseApi from './base-api';

interface Channel {
    answered: boolean;
    channel_authorized: boolean;
    custom_application_vars: Record<string, any>;
    custom_channel_vars: Record<string, any>;
    custom_sip_headers: Record<string, any>;
    destination: string;
    direction: string;
    elapsed_s: number;
    from_tag: string;
    interaction_id: string;
    is_loopback: boolean;
    is_onhold: boolean;
    request: string;
    reseller_id: string;
    resource_id: string;
    timestamp: number;
    to_tag: string;
    uuid: string;
}

export class CallsApi extends BaseApi {
    constructor() {
        super();
        return this;
    }

    public async getChannels(kazooApiUrl: string, kazooAccountId: string, kazooAuthToken: string) {
        const config = {
            cache: 'no-store',
            headers: {
                'X-Auth-Token': kazooAuthToken
            }
        };

        const url = `${kazooApiUrl}/v2/accounts/${kazooAccountId}/channels`;
        const resp = await this.fetchKazooApi(url, config);
        const channels = resp.data as Channel[];
        return channels;
    }
}
